const splitFileName = (fileName) => {
  const extensionIndex = fileName.lastIndexOf(".");

  if (extensionIndex <= 0) {
    return { baseName: fileName, extension: "" };
  }

  return {
    baseName: fileName.slice(0, extensionIndex),
    extension: fileName.slice(extensionIndex),
  };
};

const createUniqueFileName = (fileName, usedFileNames) => {
  const { baseName, extension } = splitFileName(fileName);
  let uniqueFileName = fileName;
  let duplicateNumber = 2;

  while (usedFileNames.has(uniqueFileName)) {
    uniqueFileName = `${baseName} (${duplicateNumber})${extension}`;
    duplicateNumber += 1;
  }

  usedFileNames.add(uniqueFileName);
  return uniqueFileName;
};

export const buildUniqueNoteFileEntries = (
  files = [],
  existingFileNames = [],
) => {
  const usedFileNames = new Set(
    Array.isArray(existingFileNames) ? existingFileNames : [],
  );

  return Array.from(files || [])
    .filter(Boolean)
    .map((file) => {
      const fileName = String(file.name || "file");

      return {
        file,
        fileName: createUniqueFileName(fileName, usedFileNames),
      };
    });
};
